<div [ngSwitch]="type">
    <i *ngSwitchCase="hotspotTypes.RECYCLER" class="fa fa-recycle" title="Recycler"></i>
    <i *ngSwitchCase="hotspotTypes.SERVICE_CENTER" class="fa fa-industry" title="Service Center"></i>
    <i *ngSwitchCase="hotspotTypes.CUSTOMER" class="fa fa-user" title="Customer"></i>
    <span *ngSwitchDefault>{{type | hotspotType}}</span>
</div>
